import { useRunningTimerQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { useStore } from "@src/utils/hooks";

const pollInterval = 60 * 1000; // 1 minute

export function useGetRunningTimer() {
  const { timeTrackingStore, authStore } = useStore();
  const userId = authStore.user?.id;
  const result = useRunningTimerQuery({
    skip: !userId,
    notifyOnNetworkStatusChange: true,
    pollInterval,
    variables: {
      user_id: userId ?? "",
    },
    onCompleted(data) {
      timeTrackingStore.setRunningEntry(data);
    },
    ...onError(),
  });

  timeTrackingStore.refetch = result.refetch;

  return result;
}
